import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post } from './agent';

const allocations =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'allocations', id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      list: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      export: (query = {}, headers = {}) =>
        get(url.concat('/export').concat(new QueryString(query, { multi: true }).toString(true)), headers),
      bulkDelete: (ids) => post(url.concat('/bulk-delete'), { ids }),
      bulkSetBookingType: (ids, body) => post(url.concat('/bulk-set-booking-type'), { ids, ...body }),
      bulkReassign: (ids, body) => post(url.concat('/bulk-reassign'), { ids, ...body }),
      bulkShift: (ids, body) => post(url.concat('/bulk-shift'), { ids, ...body }),
      upsert: (body) => (id ? patch : post)(url, body),
      reassign: (body) => patch(url.concat('/reassign'), body),
      clone: () => post(url.concat('/clone')),
      detailsCard: (query = {}) => get(url.concat('/details-card').concat(new QueryString(query).toString(true))),
      history: () => get(url.concat('/history')),
      split: ({ date }) => post(url.concat('/split'), { date }),
      splitByDay: () => post(url.concat('/split-by-day')),
      splitByDayCount: () => get(url.concat('/split-by-day-count')),
      splitByWeek: () => post(url.concat('/split-by-week')),
      splitByWeekCount: () => get(url.concat('/split-by-week-count')),
      splitByMonth: () => post(url.concat('/split-by-month')),
      splitByMonthCount: () => get(url.concat('/split-by-month-count')),
      removeOverlapping: () => post(url.concat('/remove-overlapping')),
      delete: () => del(url),

      getProjectDetails: (param, query = {}) =>
        get(url.concat(`/project-details/${param}`).concat(new QueryString(query).toString(true))),

      getClientDetails: (params) => get(url.concat(`/client-details/${params}`)),

      getProject: (param) => get(url.concat(`/projects/${param}`)),

      getProjectRoles: (param, query) =>
        get(url.concat(`/projects/${param}/roles`).concat(new QueryString(query).toString(true))),

      memberSchedule: {
        resources: (query = {}) =>
          get(url.concat('/member-schedule/resources').concat(new QueryString(query, { multi: true }).toString(true))),

        assignments: (query = {}) =>
          get(
            url.concat('/member-schedule/assignments').concat(new QueryString(query, { multi: true }).toString(true)),
          ),

        allocations: (query = {}) =>
          get(
            url.concat('/member-schedule/allocations').concat(new QueryString(query, { multi: true }).toString(true)),
          ),

        reassignAllocations: (projectId, body) =>
          patch(url.concat(`/member-schedule/${projectId}/reassign-allocations`), body),

        manageProjectAllocations: (projectId) =>
          get(url.concat(`/member-schedule/${projectId}/manage-allocations-permission`)),

        metrics: {
          headers: (query = {}) => post(url.concat('/member-schedule/metrics/headers'), query),
          resources: (query = {}) => post(url.concat('/member-schedule/metrics/resources'), query),
        },

        export: (query = {}, headers = {}) =>
          get(
            url.concat('/member-schedule/export').concat(new QueryString(query, { multi: true }).toString(true)),
            headers,
          ),
      },

      projectSchedule: {
        projects: (query = {}) =>
          get(url.concat('/project-schedule/projects').concat(new QueryString(query, { multi: true }).toString(true))),

        resources: (query = {}) =>
          get(url.concat('/project-schedule/resources').concat(new QueryString(query, { multi: true }).toString(true))),

        allocations: (query = {}) =>
          get(
            url.concat('/project-schedule/allocations').concat(new QueryString(query, { multi: true }).toString(true)),
          ),

        projectTeam: (query = {}) =>
          get(url.concat('/project-schedule/project-team').concat(new QueryString(query).toString(true))),

        assignAllocatedMembers: (projectId) =>
          post(url.concat(`/project-schedule/${projectId}/assign-allocated-members`)),

        reassignAllocations: (projectId, body) =>
          patch(url.concat(`/project-schedule/${projectId}/reassign-allocations`), body),

        assignableResources: (query = {}) =>
          get(url.concat('/project-schedule/assignable-resources').concat(new QueryString(query).toString(true))),

        shiftAllocations: (projectId, body) =>
          patch(url.concat(`/project-schedule/${projectId}/shift-allocations`), body),

        setProjectBookingType: (projectId, body) =>
          patch(url.concat(`/project-schedule/${projectId}/set-project-booking-type`), body),

        setResourceBookingType: (projectId, body) =>
          patch(url.concat(`/project-schedule/${projectId}/set-resource-booking-type`), body),

        hasAllocations: (projectId) => get(url.concat(`/project-schedule/${projectId}/has-allocations`)),

        metrics: {
          headers: (query = {}) => post(url.concat('/project-schedule/metrics/headers'), query),
          clients: (query = {}) => post(url.concat('/project-schedule/metrics/clients'), query),
          projects: (query = {}) => post(url.concat('/project-schedule/metrics/projects'), query),
        },

        export: (query = {}, headers = {}) =>
          get(
            url.concat('/project-schedule/export').concat(new QueryString(query, { multi: true }).toString(true)),
            headers,
          ),
      },
    };
  };

export default allocations;
